/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useState,useCallback, useContext, useEffect} from 'react'
import DropDown from '../../../components/DropDown'
import Input from '../../../components/InputBox';
import ErrorMessage from '../../../components/ErrorMessage';
import TextArea from '../../../components/TextArea';
import { dataService } from '../../../services/data.services';
import { CurrentAcademicYear } from '../../../CommonMethods/CurrentAcademicYear';
import UpdateButton from '../../../components/UpdateButton';
import GlobalContext from '../../../components/Context/GloablContext';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { CognitoData } from '../../../CommonMethods/CognitoData';
import AddSubjectShimmer from '../../Shimmer/AddSubjectShimmer';
import CardHeader from '../../CardHeader';

export default function AddSubject({actionType}) {
    const {setToastmessage,setToastErrorMessage, isSideNavBar}=useContext(GlobalContext);
    const location= useNavigate()
    const { id } = useParams()
    const {userType}=useSelector(state=>state.auth);
    const [classList, setclassList] = useState([]);
    const [viewLoading, setViewLoading] = useState(true);
    const [state, setstate] = useState({
        academic_year:'',
        class_name:'',
        subject:'',
        description:'',
        is_optional:false

    });
    const [submitSelected, setsubmitSelected] = useState(false);
    const [classnameError, setclassnameError] = useState(false)
    const [loading, setloading] = useState(false)
    const [noClasserror, setNoClasserror] = useState(false);


    /* `fetchClasses` is a function that is defined using the `useCallback` hook. It takes a `year`
    parameter and makes an API call to fetch a list of classes based on the `year` parameter and the
    `branchId`. The `branchId` is determined based on the `userType` and is either retrieved from
    local storage or from the `CognitoData` function. If the API call is successful, the list of
    classes is set using the `setclassList` function. This function is used in the `handleDropdown`
    function to update the list of classes when the academic year is changed. */
    const fetchClasses = useCallback(
        async(year) => {
            let branchId=''
            if(userType==='institution-user'){
                const branch_details=JSON.parse(localStorage.getItem('branch_details'))
                branchId=branch_details.id
            }else{
                const cognito=await CognitoData();
                branchId=cognito.idToken.payload['custom:branch_id']
            }
            try {
                let res = await dataService.GetAPI(`classes?page_number=1&filter=true&academic_year=${encodeURIComponent(year||state.academic_year)}&status=draft&sort=${encodeURIComponent(`created_at+asc`)}&branch_id=${branchId}`, true)
                const arr=[]
                if(res.data.status===200){
                    setclassList(res.data.data.data)
                    if(res.data.data.data?.length === 0){    
                        setstate((prv)=>({
                            ...prv,
                            ["class_name"]:""
                        }))                   
                        setNoClasserror(true)
                    } else {
                        setNoClasserror(false)
                    }
                }
                
            } catch (error) {
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                console.log(error)   
            }
          
        },

        [],
    )
    
    /**
     * This function retrieves data from an API endpoint and sets the state and edit values
     * accordingly.
     */
    const getViewData = async() => {
        try {
            let res = await dataService.GetAPI(`subjects/${id}`);
            setstate({
                academic_year:res.data.data.academic_year,
                class_name:res.data.data.class,
                subject:res.data.data.subject,
                description:res.data.data.description
        
            });
            fetchClasses(res.data.data.academic_year)

            setloading(false); 
            setViewLoading(false)
        } catch (error) {
            location('/404')
        }   
    }

    /* This is a `useEffect` hook that runs when the component mounts. It checks the value of
   `actionType` and if it is equal to "Edit", it calls the `getViewData` function to retrieve data
   from an API endpoint and set the state and edit values accordingly. If `actionType` is not equal
   to "Edit", it sets the `loading` state to `false` after a timeout of 0 seconds. */
    useEffect(() => {
        if(actionType === "Edit") {
            getViewData()   
        } else {
            setTimeout(() => {
                setViewLoading(false)
                setloading(false)
            }, []);
        }
    }, [])

    /**
   * This function updates the state with a new value and fetches classes based on the selected
   * academic year.
   */
    const handleDropdown = (id,value)=>{
        setstate((prv)=>({
            ...prv,
            [id]:value
        }))
        if(id==='academic_year'){
            fetchClasses(value)
        }
    }


    /**
    * This function updates the state with the new value of an input field.
    */
    const handleInput=(e)=>{
        const {id,value}=e.target
        setstate((prv)=>({
            ...prv,
            [id]:value
        }))
    }
    const excepKeys=['']


    /**
    * This function checks if all the values in the state object, except for the ones in the excepKeys
    * array, are not empty and returns a boolean value indicating if there are any errors.
    * @returns The function `handleValidation` is returning a boolean value. It returns `true` if all
    * the values in the `state` object (except for the ones specified in `excepKeys` array) are not
    * empty strings, and `false` otherwise. The function also creates an array `ErrorArray` which
    * stores the keys of the `state` object that have empty string values.
    */
    const handleValidation=()=>{
        const ErrorArray=[]
        Object.keys(state).filter((val)=>!excepKeys.includes(val)).map((key)=>{
            if(state[key]===''){
                ErrorArray.push(key)
            }
        })
        return ErrorArray?.length===0
    }
  
    /**
   * This function handles the submission of a form for creating or editing a section, sends the data
   * to an API, and displays success or error messages.
   * @returns The function `handleSubmit` is not returning anything explicitly. It is performing some
   * operations and setting some state variables based on the result of those operations.
   */
    const handleSubmit=async(e)=>{
        e.preventDefault()
        setloading(true)
        setsubmitSelected(true);
        if(!handleValidation()){
            setloading(false)
            return
        }
        try {
            const user = await CognitoData();
            const localData = JSON.parse(localStorage.getItem('branch_details'));
         
            const {academic_year,description,class_name,subject, is_optional}=state
            let body = 
            {
                "description":description,
                "class": class_name,
                "academic_year": academic_year,
                "subject":subject,
                "is_optional":is_optional,
                "branch_id" : user.idToken.payload["custom:user_type"] === "institution-user" ? localData.id : user.idToken.payload["custom:branch_id"]
            }
            let response;
            if(actionType === "Edit") {
                response = await dataService.PatchAPI(body,`subjects/${id}`);
            } else {
                response = await dataService.PostAPI(body,"subjects");
            }
            if(actionType === "Edit"){
                setToastmessage("Subject updated successfully")
            }else{
                setToastmessage("Subject added successfully")
            }
            setloading(false);
            location('/main-hub/subjects')
            
        } catch (error) {
            setloading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error(error);
        }

    }
    return (
        <CardHeader>
            <div class="mb-6 flex items-start">
                <Link to="/main-hub/subjects" >
                    <div className='flex'>
                        <img src="/images/arrow-mark-blue.svg" alt="icon" class="mt-1 cursor-pointer"/>
                        <p class="font-medium text-lg text-[#106EB4] ml-3 cursor-pointer">Back</p>
                    </div>
                </Link>
            </div>
            <div class="flex justify-between">
                <div class="text-[#344054] text-[14px] font-medium">
                    <h5 class="pageHeader addadmin" >{id === undefined ? "Add Subject" : "Edit Subject"}</h5>
                </div>
            </div>
            {viewLoading ? <AddSubjectShimmer /> : <div class="w-[90%]">
                <div class="-mx-4 flex mt-10 flex-wrap">
                    
                    <DropDown 
                        label="Academic Year"
                        options={CurrentAcademicYear()}
                        handleDropdown={handleDropdown}
                        state={state}
                        id="academic_year"
                        submitSelected={submitSelected}
                        placeholder="Select Academic Year"
                        message="Academic year is mandatory"
                    />
                    <DropDown 
                        label="Add Class"
                        isSearch
                        options={classList?.map((val)=>val.class)}
                        handleDropdown={handleDropdown}
                        state={state}
                        id="class_name"
                        submitSelected={submitSelected || noClasserror}
                        placeholder="Select Class Name"
                        message={noClasserror ? "There is no class available for this academic year" : "Class name is mandatory"}
                    />
                    <div class="px-4 w-1/3 mb-4">
                        <div class="w-full">
                            <label for="subject" class="text-f1 font-medium text-[#344054] mb-1.5">Subject Name</label>
                            <Input
                                type="text"
                                state={state}
                                id="subject"
                                handleInput={handleInput}
                                submitSelected={submitSelected}
                                setsubmitSelected={setsubmitSelected}
                                className="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border1 shadow-s7"
                                text="Subject name is mandatory"
                                placeholder ="Enter Subject Name"
                            />
                            {/* <!-- error message --> */}
                            {/* <!-- error message --> */}
                            {submitSelected && state['subject']!=='' && classnameError&&
                            <ErrorMessage error classKey={"text-f1 font-normal text-[#F04438] add-error3 pt-1.5"} message="This section name already exists in this academic year or class. Try another" />}
                        </div>
                    </div>
                    <div class="px-4 w-full mb-4">
                        <label for="Description" class="text-f1 font-medium text-[#344054] mb-1.5">Description</label>
                        <TextArea
                            type="text"
                            state={state}
                            id="description"
                            handleInput={handleInput}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                            className="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] shadow-s7 h-[128px] resize-none"
                            text="Description is mandatory"
                            placeholder ="Enter Description"
                        />
                        {/* <textarea id="description" class="w-full border border-[#D0D5DD] rounded-lg py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] shadow-s7 h-[128px] resize-none" placeholder="Enter Description"></textarea> */}
                    </div>
                </div>
                <div class="relative checkbox custom-checkBoxBlue1 checkboxOptional mb-4">
                    <input type="checkbox" id="is_optional" checked={state.is_optional} onChange={() => setstate((prv)=>({
                        ...prv,
                        ["is_optional"]: !state.is_optional
                    }))}/>
                    <label for="is_optional" class="text-f1 font-semibold text-[#000000] pl-3 w-full cursor-pointer">Mark this as an optional subject</label>
                </div>
                <div class="w-fit mb-4 mt-8 mx-auto">
                    <UpdateButton
                        ButtonName={id !== undefined ? "Update Subject" : "Add Subject"}
                        loading={loading}
                        handleOnCLick={handleSubmit}
                        classKey="w-[288px] mx-auto bg-[#106EB4] py-3 rounded-lg text-f2 font-semibold text-[#ffffff] hover:bg-[#1C8ADC] hover:duration-75 onboardInstitution"
                    />  
                </div>
            </div>}
        </CardHeader>   
    )
}
